import { Skeleton } from "@/components/ui/skeleton";

/** App-shell skeleton shown while a public page resolves its data. */
export function FullPageLoading() {
  return (
    <div
      data-testid="full-page-loading"
      className="flex-1 min-h-screen w-full flex flex-col gap-4 p-6 box-border"
    >
      <Skeleton variant="rectangular" height={48} className="rounded-md" />
      <div className="flex gap-4 flex-1 min-h-0">
        <Skeleton
          variant="rectangular"
          width={240}
          className="shrink-0 min-h-80 rounded-md"
        />
        <Skeleton
          variant="rectangular"
          className="flex-1 min-h-80 rounded-md"
        />
      </div>
    </div>
  );
}
